<template>
  <div class="drop-in-zone empty">
    <p><strong>Drag and Drop</strong> here</p>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  export default Vue.extend({
    props: {
    },
  });
</script>
